import studentTermDetailService from "../../apiServices/student/studentTermDetailService";
import { setStudentTermDetail } from "../../store/slices/student/studentTermSlice";

export function getStudentTermDetails() {
  return async function (dispatch: any, getState: any) {
    let response = await studentTermDetailService.getTermDetail();
    if (response.success) {
      dispatch(setStudentTermDetail(response.data));
    } else {
      console.log("error");
    }
  };
};
